<template>
  <div v-if="bodyShow" class="progress-main">
    <div class="bodys">
      <div class="user">
        <img :src="data.promoter_headimgurl" alt="" />
        <h2>{{data.promoter_nickname}}</h2>
      </div>
      <img src="@a/promoter_t1.png" alt="" class="prt_img" />
      <a class="prt_a" v-if="!data.has_parent" @click="acceptInvite_click"></a>
    </div>
    <van-popup class="pub_alert" v-model="alert_show">
      <div class="confirm_box">
        <p>你与「{{data.parent_nickname}}」是绑定关系中，暂时不能接受其他绑定。</p>
        <div class="btn_group">
          <a @click="$router.push({
                    path:'/training_money',
                    query:{
                        course_id:$route.query.course_id,
                        type: 100
                    }
                })">发展下级</a>
        </div>
      </div>
    </van-popup>
    <van-popup class="pub_alert" v-model="accept_show">
      <div class="confirm_box">
        <img src="@a/pro_dg.png" alt="" />
        <p>绑定成功 {{time}}S 后进入 邀请进度页面
        </p>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  invitePromoter,
  acceptInvite
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        bodyShow: false,
        data: {},
        alert_show: false,
        time: 3,
        accept_show: false
      }
    },
    methods: {
      acceptInvite_click() {
        acceptInvite({
            parent_id: this.$route.query.parent_id
          })
          .then((data) => {
            if (data.code === 10002) {
              this.$toast(data.msg);
              return
            }
            this.accept_show = true;
            let sin = setInterval(() => {
              this.time -= 1;
              if (this.time == 0) {
                clearInterval(sin)
                this.$router.push({
                  path: '/invitation_progress',
                  query: {
                    course_id: this.$route.query.course_id,
                    course_type: 'show'
                  }
                })
              }
            }, 1000)
          });
      },
      pullData() {
        invitePromoter({
          parent_id: this.$route.query.parent_id
        })
          .then((data) => {
            if (data.code === 10002) {
              this.$toast(data.msg);
              return
            }

            this.bodyShow = true;
            this.data = data;
            this.alert_show = data.has_parent;
            shareCon("training", this);
          });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.confirm_box {
  text-align: center;
  img {
    width: 86px;
    margin-top: 20px;
  }
  h2 {
    padding-bottom: 12px;
    font-size: 32px;
    color: #333;
    font-weight: bold;
  }
  p {
    margin-bottom: 30px;
    font-size: 26px;
    color: #333;
    text-align: center;
    padding: 0 20px;
    line-height: 40px;
    margin-top: 20px;
  }
  .btn_group {
    a {
      width: 100%;
      font-size: 34px;
      color: #EB5032;
      text-align: center;
    }
  }
}

.bodys {
  background: url(../../../assets/promoter_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  padding-top: 60px;
  .user {
    text-align: center;
    img {
      width: 120px;
      border-radius: 50%;
    }
    h2 {
      font-size: 32px;
      color: #fff;
      line-height: 40px;
      margin-top: 15px;
    }
  }
  img.prt_img {
    position: absolute;
    bottom: 225px;
    left: 96px;
    width: 558px;
  }
  a.prt_a {
    position: absolute;
    bottom: 66px;
    left: 30px;
    width: 690px;
    height: 105px;
    background: url(../../../assets/promoter_a1.png) no-repeat top center;
    background-size: cover;
  }
}
</style>
